export default __webpack_public_path__ + "472386d613de4736a591d6d84900edc9.svg";